// extracted by mini-css-extract-plugin
export default {"root":"ReceivedEvaluation_root__xRE3p"};